import { fromFetch } from 'rxjs/fetch';
import { switchMap, of, catchError } from 'rxjs';
import { getSelfGuidedTourCommunityTourableSpecs } from 'constants/routes';

/**
 * Fetches the tourable siblings for a given community Id.
 * @param {string} communityId - The community Id to fetch spec details for.
 * @returns {Observable} An observable that emits the tourable siblings array or an error object.
 */
export default function getCommunityTourableSpecs(communityId) {
  const url = `${getSelfGuidedTourCommunityTourableSpecs}?communityId=${communityId}`;

  return fromFetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).pipe(
    switchMap((response) => {
      if (response.ok) {
        return response.json();
      }
      return of({ error: true, message: 'Error fetching data' });
    }),
    catchError((error) => of({ error: true, message: error.message }))
  );
}
